import router from '@ps/router'
import { saveFile } from '@ps/api/editor/file'
import _ from 'lodash'
import assets from '@ps/bridge/qc/assets'
import { saveGlobalUrlMap } from '@ps/bridge/resource/global-url-map'
import { projectBasicPath } from '@ps/workbench/config'
import { parseBinContent } from '@ps/utils/game'
import { Base64 } from 'js-base64'
import * as editorScript from '@ps/bridge/qc/scripts/editor'

export function generateCell(config) {
  const cellHeight =
    (config.gridHeight - (config.rowCount - 1) * config.rowSpace) /
    config.rowCount
  const cellWidth =
    (config.gridWidth - (config.colCount - 1) * config.colSpace) /
    config.colCount
  const cells = []
  for (let rowIndex = 0; rowIndex < config.rowCount; rowIndex++) {
    cells[rowIndex] = []
    for (let colIndex = 0; colIndex < config.colCount; colIndex++) {
      const isOffset = config.gridType === 'offset' && rowIndex % 2 !== 0
      cells[rowIndex][colIndex] = {
        x: isOffset
          ? (cellWidth + config.colSpace) * colIndex + cellWidth / 2
          : (cellWidth + config.colSpace) * colIndex,
        y: (cellHeight + config.rowSpace) * rowIndex,
        typeId: 0,
        width: cellWidth,
        height: cellHeight,
        image: '',
        bin: '',
        active: false,
        background: {
          width: cellWidth,
          height: cellHeight,
          ...config.cellBackground,
          bin: '',
          image: '',
        },
      }
    }
  }
  return {
    cellWidth,
    cellHeight,
    cells,
  }
}

export function removeAllChess(config) {
  const tempConfig = _.cloneDeep(config)
  for (let rowIndex = 0; rowIndex < tempConfig.rowCount; rowIndex++) {
    for (let colIndex = 0; colIndex < tempConfig.colCount; colIndex++) {
      tempConfig.cells[rowIndex][colIndex] = removeChess(
        tempConfig.cells[rowIndex][colIndex],
      )
    }
  }
  return tempConfig
}

export function removeChess(chess) {
  chess.image = ''
  chess.bin = ''
  chess.typeId = 0
  return chess
}

const _default = {
  scene: 'common',
  group: 'grid',
  gridType: 'normal',
  cellBackground: {
    image: '',
    bin: '',
    alpha: 1,
  },
  // 暂不开放棋盘背景修改
  background: {
    x: 0,
    y: 0,
    image: '',
    bin: '',
    alpha: 1,
  },
  items: [],
  cells: [],
}

export function cookGridData(
  { commit, state, dispatch, rootState },
  params = {
    gridWidth: 500,
    gridHeight: 500,
    cellWidth: 0, // 格子宽高
    cellHeight: 0, // 格子宽高
    rowCount: 5,
    colCount: 5,
    rowSpace: 0,
    colSpace: 0,
    cellBackground: {
      image: '',
      bin: '',
      alpha: 1,
    },
    cellBackgroundActive: false,
    percentConfig: {
      active: false,
      percentMap: {},
    },
  },
) {
  const config = {
    ..._default,
    ...params,
  }

  const cells = generateCell(config)
  return {
    ...config,
    ...cells,
  }
}

export async function saveItem({ files, resourcePath }) {
  const projectKey = Number(router.currentRoute.query.id)
  let bin = ''
  let image = ''
  const newpath = {}
  const promiseAll = []
  files.forEach((file) => {
    const path = `${resourcePath}${file.name}`
    if (file.name.indexOf('.bin') > -1) {
      bin = file.name
      const content = parseBinContent(Base64.decode(file.data))
      newpath[content.uuid] = path
    } else {
      image = file.name
    }
    promiseAll.push(
      saveFile(
        {
          pid: projectKey,
          path,
          enc: 'base64',
        },
        file.data,
      ),
    )
  })
  await Promise.all(promiseAll)
  const temp = {
    ...assets.uuid2UrlConf,
    ...newpath,
  }
  await saveGlobalUrlMap({
    projectKey,
    uuid2url: temp,
  })
  // 新增替换图片时需要更新内存中的uuid2urlConf
  assets.updateUuid2UrlConf(temp)
  return { bin, image }
}

export function randomChess(gridConfig) {
  const percentConfig = gridConfig.percentConfig
  const items = gridConfig.items.filter(
    (item) => item.active && percentConfig['percentMap'][item.typeId],
  )
  const cells = _.cloneDeep(gridConfig.cells)
  // 随机函数，默认根据percentMap百分比分配
  const getChess = () => {
    const sign = Math.round(Math.random() * 100)
    const sum = (list) => {
      let s = 0
      list.forEach((item) => {
        s += percentConfig['percentMap'][item.typeId]
      })
      return s
    }
    let typeId = ''
    items.forEach((item, index) => {
      // index为0最小值为0，index大于0
      let min = ''
      if (index > 0) {
        min = sum(items.filter((item, i) => i <= index - 1))
      } else {
        min = 0
      }
      const max = sum(items.filter((item, i) => i <= index))
      if (sign >= min && sign <= max && !typeId) {
        typeId = item.typeId
      }
    })
    return typeId
  }
  cells.forEach((row, rowIndex) => {
    row.forEach((col, colIndex) => {
      if (row[colIndex].active) {
        const ranChess = getChess()
        const randomChess = items.find((item) => item.typeId === ranChess)
        row[colIndex] = {
          ...row[colIndex],
          ..._.pick(randomChess, ['typeId', 'bin', 'image']),
        }
      }
    })
  })
  return cells
}

export function getUrlByPath(path) {
  const projectKey = Number(router.currentRoute.query.id)
  return `${projectBasicPath}${projectKey}/resource/common/grid/${path}`
}

export function refreshGrid(data) {
  const config = _.cloneDeep(data)
  const cellHeight =
    (config.gridHeight - (config.rowCount - 1) * config.rowSpace) /
    config.rowCount
  const cellWidth =
    (config.gridWidth - (config.colCount - 1) * config.colSpace) /
    config.colCount
  config.cells.forEach((row, rowIndex) => {
    row.forEach((col, colIndex) => {
      // 使用棋子
      const temp = config.items.find((item) => item.typeId === col.typeId)
      // 刷新棋子
      row[colIndex].bin = temp && temp.active && col.active ? temp.bin : ''
      row[colIndex].image = temp && temp.active && col.active ? temp.image : ''
      row[colIndex].typeId = temp && temp.active && col.active ? temp.typeId : 0
      row[colIndex].background.image =
        config.cellBackgroundActive && col.active
          ? config.cellBackground.image
          : ''
      row[colIndex].background.bin =
        config.cellBackgroundActive && col.active
          ? config.cellBackground.bin
          : ''
      // 更新座标
      const isOffsetX = config.gridType === 'offset' && rowIndex % 2 !== 0
      const isOffsetY = config.gridType === 'offsetY' && colIndex % 2 !== 0
      row[colIndex].x = (cellWidth + config.colSpace) * colIndex
      row[colIndex].y = (cellHeight + config.rowSpace) * rowIndex
      if (isOffsetX) {
        row[colIndex].x = row[colIndex].x + cellWidth / 2
      }
      if (isOffsetY) {
        row[colIndex].y = row[colIndex].y + cellHeight / 2
      }
      // 更新背景尺寸
      row[colIndex].background.width = cellWidth
      row[colIndex].background.height = cellHeight
      // 更新棋子尺寸
      row[colIndex].width = cellWidth
      row[colIndex].height = cellHeight
    })
  })
  config.cellHeight = cellHeight
  config.cellWidth = cellWidth
  return config
}

export function updateScriptGrids(node, config, is_internal_account) {
  node.getScript('ps.GridView').config.gridsConfig = _.cloneDeep(config)
  // 内部帐号更新节点预设数据
  if (is_internal_account) {
    const editorData = editorScript.getScript(node)
    editorData.$data.gridsConfig = _.cloneDeep(config)
  }
}
